import makeStyles from '@mui/styles/makeStyles'
import { CAMPAIGN_STATUS } from '../../../reducers/campaign-edit/slice'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    height: 60,
    borderBottom: '1px solid #E0E0E0',
    '&:hover': {
      backgroundColor: palette.background.selected,
      cursor: 'pointer'
    },
    '&:focus': {
      backgroundColor: palette.background.selected
    },
    '&::before': {
      content: 'close-quote',
      position: 'absolute',
      borderRadius: spacing(0, 2, 2, 0),
      width: spacing(0.75),
      height: spacing(3.75),
      backgroundColor: ({ status }) => {
        switch (status) {
          case CAMPAIGN_STATUS.live: return palette.success.main
          case CAMPAIGN_STATUS.scheduled: return palette.primary.main
          default: return palette.grey.main
        }
      }
    },
    pointerEvents: ({ isLoading }) => isLoading ? 'none' : 'initial'
  },
  campaignColumn: {
    padding: spacing(0, 2.5, 0, 3)
  },
  status: {
    color: ({ status }) => {
      switch (status) {
        case CAMPAIGN_STATUS.live: return palette.success.main
        case CAMPAIGN_STATUS.scheduled: return palette.primary.main
        default: return palette.grey.main
      }
    }
  },
  defaultText: {
    position: 'relative'
  },
  defaultIcon: {
    width: spacing(2),
    height: spacing(2),
    position: 'absolute',
    top: 2
  }
}))
